import { releaseNoteCrudConfig } from '@/config/objects/release-notes';
import { CrudListView, PageContainer } from '@startupquickstart/frontend';

/**
 * Release Notes list page. Displays all "What's New" entries in a searchable,
 * filterable, read-only table. Release notes are managed as repo content files
 * synced at API boot, so there are no create / edit / delete actions.
 * Internal-only.
 */
export function ReleaseNotesPage() {
  const breadcrumbs = [
    { label: 'Home', href: '/' },
    { label: 'Release Notes', current: true },
  ];

  return (
    <PageContainer>
      {/* data-tour anchor: the shipped first release note targets this selector. */}
      <div data-tour="release-notes-list">
        <CrudListView
          config={releaseNoteCrudConfig}
          baseUrl="/release-notes"
          breadcrumbs={breadcrumbs}
        />
      </div>
    </PageContainer>
  );
}
